import { render } from "./ChatHost.vue?vue&type=template&id=308cff52&scoped=true"
import script from "./ChatHost.vue?vue&type=script&lang=js"
export * from "./ChatHost.vue?vue&type=script&lang=js"

import "./ChatHost.vue?vue&type=style&index=0&id=308cff52&lang=scss&scoped=true"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308cff52"]])

export default __exports__